module.exports = require('./Register');
